/**
 * Form validation
 *
 * @since 1.0.0
 */
import 'script-loader!hyperform/dist/hyperform.js'

const FormValidation = () => {
  window.hyperform(window)
  const inputs = document.querySelectorAll('input,textarea,select')

  ;[...inputs].forEach(input => {
    if (input.required) {
      input.addEventListener('invalid', e => e.preventDefault())
    }
  })

  // register a custom validator for sum
  const sum = document.querySelector('input[name="sum"]')

  if (sum) {
    hyperform.addValidator( document.querySelector('input[name="sum"]'), (element) => {
      const nr_1 = document.querySelector('input[name="nr_1"]')
      const nr_2 = document.querySelector('input[name="nr_2"]')
      const answer = parseInt(nr_1.value) + parseInt(nr_2.value)

      let valid = parseInt(element.value) === answer
      element.setCustomValidity( valid ? '' : 'Wrong answer' )

      return valid
    })
  }

  initRecaptcha()
}

let recaptchaGereed = null

/**
 * Het reCAPTCHA-script is circa 350 kB en werd op elke pagina geladen, ook
 * voor bezoekers die nooit een formulier openen. Het laadt nu pas bij de
 * eerste interactie met een formulier. onSubmit wacht op deze promise, zodat
 * een inzending nooit ongeverifieerd doorgaat als het script nog onderweg is.
 */
function initRecaptcha () {
  if (typeof window.site.vars.recaptcha_key === 'undefined' ||
    !window.site.vars.recaptcha_key) {
    return
  }

  const forms = document.querySelectorAll('form.js-form')
  if (!forms.length) {
    return
  }

  ;[...forms].forEach((form) => {
    form.addEventListener('validate', onSubmit)
    ;['focusin', 'pointerdown'].forEach((gebeurtenis) => {
      form.addEventListener(gebeurtenis, laadRecaptcha, { once: true })
    })
  })
}

function laadRecaptcha () {
  if (recaptchaGereed) {
    return recaptchaGereed
  }

  recaptchaGereed = new Promise((resolve, reject) => {
    window.initRecaptcha = () => {
      onRecaptchaLoad()
      resolve()
    }

    let script = document.createElement('script')
    script.setAttribute('src',
      'https://www.google.com/recaptcha/api.js?onload=initRecaptcha&render=explicit')
    script.setAttribute('type', 'text/javascript')
    script.onerror = () => reject(new Error('reCAPTCHA kon niet geladen worden'))

    document.body.appendChild(script)
  })

  return recaptchaGereed
}

function onRecaptchaLoad () {
  const forms = document.querySelectorAll('form.js-form');

  [...forms].forEach((form) => {
    let recaptchaContainer = document.createElement('div')
    recaptchaContainer.classList.add('g-recaptcha')

    form.recaptcha = {
      id: grecaptcha.render(recaptchaContainer, {
        sitekey: window.site.vars.recaptcha_key,
        size: 'invisible',
        callback: token => onRecaptchaCallback(token, form),
      }),
      validated: false,
    }

    form.appendChild(recaptchaContainer)
  })
}

function onSubmit (e) {
  const form = e.target

  if (form.recaptcha && form.recaptcha.validated) {
    return
  }

  // Altijd tegenhouden tot de verificatie rond is. Was het script nog niet
  // geladen (submit via Enter zonder focus-event), dan start het hier alsnog.
  e.preventDefault()

  laadRecaptcha()
    .then(() => {
      if (!form.recaptcha || typeof form.recaptcha.id === 'undefined') {
        throw new Error('reCAPTCHA is niet geinitialiseerd voor dit formulier')
      }
      grecaptcha.execute(form.recaptcha.id)
    })
    .catch(() => {
      // Laat de bezoeker niet met een dood formulier achter: zonder
      // verificatie doorsturen en de servercheck het laten afhandelen.
      // Eerst doorlaten markeren: de mislukte laadbelofte blijft bewaard, dus
      // zonder deze vlag start de klik hieronder dezelfde catch eindeloos opnieuw.
      form.recaptcha = Object.assign(form.recaptcha || {}, { validated: true })
      const buttons = form.querySelectorAll('.js-loading-button');
      [...buttons].forEach((button) => button.click())
    })
}

function onRecaptchaCallback (token, form) {
  form.recaptcha.validated = true

  const buttons = form.querySelectorAll('.js-loading-button');

  [...buttons].forEach((button) => {
    button.click()
  })
}

export default FormValidation

// WEBPACK FOOTER //
// ./src/js/modules/FormValidation.js